<mbs-modal [title]="baseModal.data.title"
           [isCustomModal]="true"
           [showFooter]="true"
           [titleTextOverflow]="true"
           #modal>

  <div modal-body>
    {{ "shared:licenses.releaseTrialModal.description" | i18next }}
    <mbs-alert *ngIf="baseModal.data.isDeepInstinct"
               class="mt-2"
               [icon]="true"
               [type]="MbsPopupType.warning">
      The instance of Deep Instinct will be uninstalled from the target computer. If the computer is currently offline,
      this will be done once it is online again
    </mbs-alert>
  </div>
  <ng-container modalFooter>
    <mbs-button type="primary"
                [loading]="loading"
                (click)="release()">{{ 'shared:licenses.releaseModal.submit' | i18next: { format: 'title' } }}
    </mbs-button>
    <mbs-button type="secondary"
                data-dismiss="modal"
                (click)="modal.close()">{{ 'shared:licenses.common.cancel' | i18next: { format: 'title' } }}
    </mbs-button>
  </ng-container>
</mbs-modal>
